import { render, staticRenderFns } from "./UnitMultiselect.vue?vue&type=template&id=36ae304c&"
import script from "./UnitMultiselect.vue?vue&type=script&lang=ts&"
export * from "./UnitMultiselect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports